/* eslint-disable import/no-unused-modules */
import { ActivityId } from '@/administration/pages/Course/store/types';
import { QuestionAnswer } from '@/component/customEditorV2/ui/elements/QuizQuestionElement/Edit/QuestionAnswers';
import { RLearningActivityType } from '@/store/v2';

export type ActivityContent = {
  title: string;
  text?: string;
  version?: string;
  description?: string;
  sectionPath?: string[];
  postId?: number;
  level?: string;
  effortHours?: number;
  effortMinutes?: number;

  // Practical Assessment Task
  peerReviewEnabled?: boolean;
  // Quiz
  passingCriteria?: number;
  questions?: QuestionAnswer[];
};

export enum ActivityType {
  Question = RLearningActivityType.Question,
  Module = RLearningActivityType.Module,
  Reflection = RLearningActivityType.Reflection,
  Page = RLearningActivityType.Page,
  Quiz = RLearningActivityType.Quiz,
  Assignment = RLearningActivityType.Assignment,

  // TODO: To be added to RLearningActivityType
  PracticalAssessmentText = 'PRACTICAL_ASSESSMENT_TEXT', // RLearningActivityType.PracticalAssessmentTask
  PracticalAssessmentDocument = 'PRACTICAL_ASSESSMENT_DOCUMENT', // RLearningActivityType.PracticalAssessmentTask
  PracticalAssessmentVideo = 'PRACTICAL_ASSESSMENT_VIDEO', // RLearningActivityType.PracticalAssessmentTask

  // Fronted-specific types
  Result = 'RESULT',
}

export type Activity = {
  id: ActivityId;
  remoteId?: number;
  remoteParentActivityId?: number;
  parentActivityId?: string;
  order: number;
  type: ActivityType;
  content: ActivityContent;

  collapsed?: boolean;
  active?: boolean;
  hasError?: boolean;
  completed?: boolean;
};

export type TreeActivity = Activity & { children?: Activity[] };
